export const styles = {
  accordion: { width: "100%", mb: 2 },
  sumary: { flexDirection: "row-reverse", gap: 1 },
  boxCard: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    width: "100%",
    "@media (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  card: {
    width: "120px",
    position: "relative",
    height: "100%",

    "@media (max-width: 600px)": {
      width: "100%",
    },
    boxShadow:
      "0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 4px 10px 0px rgba(0, 0, 0, 0.08)",
    backgroundColor: "background.card",
    transition: "box-shadow 0.2s ease, transform 0.2s ease",
    "&:hover": {
      boxShadow:
        "0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 8px 20px 0px rgba(0, 0, 0, 0.12)",
      transform: "translateY(-2px)",
    },
  },
  cardAction: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "180px",
    padding: "20px",
    gap: 1,
  },
  icon: {
    fontSize: "45px",
  },
  title: {
    fontSize: "18px",
    fontWeight: 500,
  },
  textfield: { width: { md: "360px", sm: "260px", xs: "160px" } },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  buttonCancelDialog: {
    backgroundColor: "background.textField",
    color: "text.primary",
  },
};
